import React from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import SectionCard from './SectionCard';
import { urlToFunnel, openExternalUrl } from '../utils/external';

export default function QrPreviewCard({ restaurant, onOpenFullscreen }) {
  if (!restaurant?.slug) return null;
  const url = urlToFunnel(restaurant.slug);

  const handleCopy = async () => {
    try {
      if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
        await navigator.clipboard.writeText(url);
      }
    } catch (_) {}
  };

  return (
    <SectionCard title="📱 Mon QR Code">
      <div style={styles.row}>
        <div style={styles.qrWrap}>
          <QRCodeCanvas
            value={url}
            size={88}
            bgColor="#FFFFFF"
            fgColor="#1A1A1A"
            level="M"
            includeMargin={false}
          />
        </div>
        <div style={styles.body}>
          <div style={styles.urlLabel}>Lien public du funnel</div>
          <div style={styles.url}>{url}</div>
          <div style={styles.actions}>
            <button type="button" onClick={onOpenFullscreen} style={styles.primaryBtn}>
              Voir en grand
            </button>
            <button type="button" onClick={handleCopy} style={styles.linkBtn}>
              Copier le lien
            </button>
            <button type="button" onClick={() => openExternalUrl(url)} style={styles.linkBtn}>
              Ouvrir
            </button>
          </div>
        </div>
      </div>
    </SectionCard>
  );
}

const styles = {
  row: {
    display: 'flex',
    gap: 14,
    alignItems: 'flex-start',
  },
  qrWrap: {
    flexShrink: 0,
    background: '#FFFFFF',
    border: '1px solid #EDEAE3',
    borderRadius: 12,
    padding: 6,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  body: {
    flex: 1,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
  },
  urlLabel: {
    fontSize: 11,
    fontWeight: 600,
    color: '#6B6B6B',
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
  url: {
    fontSize: 12,
    color: '#1A1A1A',
    fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  actions: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 6,
    marginTop: 6,
  },
  primaryBtn: {
    background: '#E8502A',
    color: '#FFFFFF',
    border: 'none',
    borderRadius: 999,
    padding: '6px 12px',
    fontSize: 12,
    fontWeight: 600,
    cursor: 'pointer',
    fontFamily: 'inherit',
  },
  linkBtn: {
    background: 'transparent',
    border: '1px solid #E5E5E0',
    borderRadius: 999,
    padding: '6px 12px',
    fontSize: 12,
    fontWeight: 600,
    color: '#1A1A1A',
    cursor: 'pointer',
    fontFamily: 'inherit',
  },
};
